module.exports = __webpack_public_path__ + "media/images/icons/outlined/border-d88bca5033753a49d773d65cc81e59f2.svg";